export { default } from './PageBlogPosts.vue'
